// @flow
import SignPrice from './SignPrice';
import SignContainer from './SignContainer';

class SignProcessConfig {
  processTypes = {
    NATURAL_PERSON: [],
    NATURAL_PERSON_RUC: [],
    LEGAL_PERSON: [],
  };
  containers: ?SignContainer[];

  static signProcessTypes = {
    NATURAL_PERSON: 'NATURAL_PERSON',
    NATURAL_PERSON_RUC: 'NATURAL_PERSON_RUC',
    LEGAL_PERSON: 'LEGAL_PERSON',
  };

  static signPriceCode = {
    NATURAL_PERSON_RUC_2_YEARS: 'NATURAL_PERSON_RUC_2_YEARS',
  };

  
  static signContainCode = {
    NATURAL_PERSON_ARCHIVO: 'archivo',
  };

  static parse(raw: any): ?SignProcessConfig {
    if (raw) {
      let config: SignProcessConfig = new SignProcessConfig();
      const keys: string[] = Object.keys(raw.processTypes);
      for (let key of keys) {
        config.processTypes[ key ] = SignPrice.parseList(raw.processTypes[ key ]);
      }
      config.containers = raw.containers || [];
      return config;
    }
  }
}

export default SignProcessConfig;
